import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const EmptyStateForms = ({ trainingId }: { trainingId: number }) => {
  const { navigation } = useNavigation()
  return (
    <Box gap="s12" alignItems="center" paddingTop="s48">
      <Icon.Large icon="user-interaction-review_chart" color="iconSecondary" />
      <Box gap="s24" alignItems="center">
        <Box alignItems="center" gap="s12">
          <Text size="400" color="textPrimary" weight="semibold">
            {i18n.t('trainings.surveys.empty.title')}
          </Text>
          <Text size="300" weight="normal" color="textSecondary" lineClamp={2}>
            {i18n.t('trainings.surveys.empty.description')}
          </Text>
        </Box>
        <Box>
          <Button.Router
            iconName="add"
            type="primary"
            to={navigation.trainings.list.details_revamp.view.surveys.select.fullPath({
              id: trainingId,
            })}
          >
            {i18n.t('trainings.surveys.empty.cta')}
          </Button.Router>
        </Box>
      </Box>
    </Box>
  )
}
